<div class="functions-list-wrapper">
  @for (func of functions(); track func) {
    <mat-card class="clickable-card" (click)="edit.emit(func?.id || '')">
      <mat-card-content class="function-card-content">
        <div class="function-icon-and-info">
          <mat-icon class="capability-icon">offline_bolt</mat-icon>
          <div>
            <div>
              {{ func.id }}
            </div>
            <div class="function-description">
              {{ func.description }}
            </div>
          </div>
        </div>
        <button mat-icon-button (click)="remove.emit(func?.id || ''); $event.stopPropagation()" class="remove-button">
          <mat-icon>clear</mat-icon>
        </button>
      </mat-card-content>
    </mat-card>
  }
</div>
